/**
 * @generated SignedSource<<abf136cdfb0ed470e5f9b0ab44672821>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MATOrganizationTypeEnum = "academy" | "private" | "school" | "%future added value";
export type MATOrganizationCreateInput = {
  createdBy: string;
  prefix: string;
  title: string;
  type: MATOrganizationTypeEnum;
};
export type MATOrganizationCreateDialog_organizationCreateMutation$variables = {
  input: MATOrganizationCreateInput;
};
export type MATOrganizationCreateDialog_organizationCreateMutation$data = {
  readonly organizationCreate: {
    readonly id: string;
  };
};
export type MATOrganizationCreateDialog_organizationCreateMutation = {
  response: MATOrganizationCreateDialog_organizationCreateMutation$data;
  variables: MATOrganizationCreateDialog_organizationCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MATOrganization",
    "kind": "LinkedField",
    "name": "organizationCreate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MATOrganizationCreateDialog_organizationCreateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MATOrganizationCreateDialog_organizationCreateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "39faf5522017e4db53901cfc33bc656e",
    "id": null,
    "metadata": {},
    "name": "MATOrganizationCreateDialog_organizationCreateMutation",
    "operationKind": "mutation",
    "text": "mutation MATOrganizationCreateDialog_organizationCreateMutation(\n  $input: MATOrganizationCreateInput!\n) {\n  organizationCreate(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "9f249b5ac21e3f1bd6a5a087481e7502";

export default node;
